export  const vacancies = [
    // {
    //     title: 'Desenvolvedor Back-end',
    //     exp:'Pleno',
    //     time:'Tempo Integral',
    //     type:'Efetivo/CLT',
    //     url:'google.com'
    // },
    // {
    //     title: 'Desenvolvedor front-end',
    //     exp:'Junior',
    //     time:'Tempo Integral',
    //     type:'Efetivo/CLT',
    //     url:'google.com'
    // },
]